import PropTypes from 'prop-types'
import { getContext, withProps, mapProps } from 'recompose'
import Divider from './Divider'

import Element from './Element'

const withTheme = getContext({ theme: PropTypes.object })

// const addClasses = custom =>
//   mapProps(({ classes, ...rest }) => {
//     return {
//       classes: custom.concat(classes),
//       ...rest
//     }
//   })

const addSizes = type =>
  mapProps(({ size, spacing, gutter, dir, horz, vert, classes, ...rest }) => {
    return {
      classes: [
        ...((classes && classes) || []),
        ...((size && [`${type}-${size}`]) || [type]),
        ...((spacing && [`bottom-margin-${spacing}`]) || []),
        ...((gutter && [`gutter-${gutter}`]) || []),
        ...((dir && ((dir === 'vertical' && ['flex-vertical']) || ['flex-row'])) || []),
        ...((horz &&
          ((horz === 'left' && ['flex-left']) ||
            (horz === 'right' && ['flex-right']) ||
            (horz === 'center' && ['flex-center']))) ||
          []),
        ...((vert &&
          ((vert === 'top' && ['flex-top']) ||
            (vert === 'middle' && ['flex-middle']) ||
            (vert === 'bottom' && ['flex-bottom']))) ||
          []),
      ],
      ...rest,
    }
  })

// Element with injected theme
const themedElement = withTheme(Element)
// Wrappers with recompose helpers
const Container = withProps({ classes: ['container'] })(themedElement) // Container has fixed class
const Row = addSizes('flex-row')(themedElement)
const Column = addSizes('flex-column')(themedElement)
const Cell = addSizes('flex-cell')(themedElement)
const Flex = addSizes()(themedElement)
// const Box = addClasses(['flex-cell', 'bordered-box'])(themedElement)

export { themedElement as Element, Container, Row, Column, Cell, Flex }

// Static dumb elements (stateless functional components)
const themedDivider = withTheme(Divider)

export { themedDivider as Divider }
export default Element



// WEBPACK FOOTER //
// ./ui/Element/index.js